module.exports = __webpack_public_path__ + "./images/82ce780205a2949490f2d115cff5e97d.webp";